<template>
  <div>
    <StepHeader :title="'Do You Have Any Additional\nIncome Sources?'"/>
    <StepContent
      width="md"
    >
      <AppButtonList
        :columns="2"
        :buttons="buttons"
        :value="has_additional_income"
        flex-row
        label="Please Select"
        @input="handleClick($event)"
      />
    </StepContent>

    <StepFooter>
      <AppButtonContinue
        v-data-layer
        :data-layer="[datalayerContinue, datalayerButtonList]"
        @click="handleContinue"
      >
        Continue
      </AppButtonContinue>

      <StepTooltip>
        Additional income sources can include a part time job, child support, alimony, etc.
      </StepTooltip>
    </StepFooter>
  </div>
</template>

<script>
import StepHeader from '@/components/common/step/StepHeader'
import StepContent from '@/components/common/step/StepContent'
import StepFooter from '@/components/common/step/StepFooter'
import StepTooltip from '@/components/common/step/StepTooltip'
import AppButtonList from '@/components/common/buttons/AppButtonList'
import AppButtonContinue from '@/components/common/buttons/AppButtonContinue'

export default {
  // Name
  name: 'additional-income',

  // Components
  components: {
    StepHeader,
    StepContent,
    StepFooter,
    StepTooltip,
    AppButtonList,
    AppButtonContinue
  },

  // Data
  data () {
    return {
      datalayerStepName: 'additional_income',
      fieldName: 'has_additional_income',
      buttons: [{
        text: 'Yes',
        value: 'Yes',
        datalayer: 'yes'
      }, {
        text: 'No',
        value: 'No',
        datalayer: 'no'
      }]
    }
  },

  // Computed
  computed: {
    has_additional_income () {
      return this.$store.state.application[this.fieldName]
    },

    selectedButton () {
      return this.buttons.find((button) => button.value === this.has_additional_income)
    },

    datalayerContinue () {
      return `${this.datalayerStepName}_continue`
    },

    datalayerButtonList () {
      if (!this.selectedButton) return
      return `${this.datalayerStepName}_${this.selectedButton.datalayer}`
    }
  },

  // Created
  created () {
    if (!this.has_additional_income) {
      this.$store.updateApplication(
        this.fieldName,
        this.buttons[0].value
      )
    }
  },

  // Methods
  methods: {
    handleClick (event) {
      this.$store.updateApplication(this.fieldName, event)
    },

    /**
     * Handle Continue
     * If user selects no, clear any data they may have entered in the 'notes'
     * (handles edge case where user enters additional income amounts, but decides
     * not to include that information)
     *
     * Further edge case: If the user enters additional income amounts, then goes back to change
     * their primary income such that their calculated monthly income is NOT within the desired
     * range, any information in the notes field will remain
     */
    handleContinue () {
      if (this.has_additional_income === 'No') {
        this.$store.updateApplication('additionalIncome', undefined)
        this.$store.updateApplication('csr_notes__c', undefined)
      }
      this.$emit('next')
    }
  }
}
</script>

<style>
</style>
